import React from 'react';
import { FormattedMessage } from 'react-intl';
import VitalChart from '../vital-chart';
import { VitalItemSC } from './vital-list.styled';
import VitalItemHeader from './vital-item-header';
import VitalItemFooter from './vital-item-footer';
import { IVitalListEntry } from '../../../../types/life-id';

export type VitalItemProps = {
  vitalListEntry: IVitalListEntry;
  onDetailOpen(): void;
};

const VitalItem: React.FC<VitalItemProps> = ({ vitalListEntry, onDetailOpen }) => {
  const { summaryChartProps, average, status } = vitalListEntry;
  return (
    <VitalItemSC>
      <VitalItemHeader
        icon={<img src={vitalListEntry.iconSrc} alt="" width="24" height="24" />}
        title={vitalListEntry.title}
      />
      <div className="vi-body">
        <div className="vi-chart-col">
          <VitalChart {...summaryChartProps} />
        </div>
        <div className="vi-data-col">
          <div className="vi-data-row">
            <span>
              <FormattedMessage id="life_id.state" />
            </span>
            <b style={{ textTransform: 'capitalize' }}>
              {Array.isArray(status) ? (
                <>
                  <FormattedMessage id={status[0]} />/ <FormattedMessage id={status[1]} />
                </>
              ) : (
                <FormattedMessage id={status} />
              )}
            </b>
          </div>
          <div className="vi-data-row">
            <span>
              <FormattedMessage id="life_id.average" />
            </span>
            <b>
              {average} <FormattedMessage id={summaryChartProps.unit} />
            </b>
          </div>
        </div>
      </div>
      <VitalItemFooter
        onDetailOpen={onDetailOpen}
        skipBadgeTranslation={vitalListEntry.skipBadgeTranslation}
        badgeType={vitalListEntry.badgeType}
        badgeText={vitalListEntry.badgeText}
      />
    </VitalItemSC>
  );
};

export default VitalItem;
